import { ModulesMap, ModulesConfigMap } from "../data/modulesMaps"
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	createMachine: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINES].CREATE_MACHINE
	},
	getAvailableMachines: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINES].GET_AVAIABLE_MACHINES
	},
	getBasedMachines: {
		useCache: true,
		cacheStorage: STORE_MAP.BASE,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINES].GET_AVAIABLE_MACHINES,
	},
	getExtendedMachines: {
		useCache: true,
		cacheStorage: STORE_MAP.EXTENDED,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINES].GET_AVAIABLE_MACHINES,
	},
	getPreviewMachine: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINES].GET_PREVIEW_MACHINE,
	},
	getMachinePopup: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINES].GET_POPUP_MACHINE,
	},
	deleteMachine: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINES].DELETE_MACHINE
	},
	getMachine: {
		useCache: true,
		isSingleCachedEntity: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINES].GET_MACHINE
	},
	editMachine: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINES].EDIT_MACHINE
	},
	putMachine: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINES].PUT_MACHINE,
	},

	// Fuel tanks
	getFuelTank: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINES].GET_FUEL_TANK
	},
	createFuelTank: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINES].CREATE_FUEL_TANK
	},
	editFuelTank: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINES].EDIT_FUEL_TANK
	},
	deleteFuelTank: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINES].DELETE_FUEL_TANK
	},
	getSensorsValues: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINES].GET_SENSORS_VALUES
	},
	getRawGPSParams: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINES].GET_RAW_GPS_PARAMS
	}
}
